// Shim for react-on-rails optional react-dom/client import on React 17.
const ReactDOM = require('react-dom');

module.exports = {
  ...ReactDOM,
  createRoot(container) {
    return {
      render(element) {
        ReactDOM.render(element, container);
      },
      unmount() {
        ReactDOM.unmountComponentAtNode(container);
      },
    };
  },
  hydrateRoot(container, element) {
    ReactDOM.hydrate(element, container);
    return {
      render(el) {
        ReactDOM.render(el, container);
      },
      unmount() {
        ReactDOM.unmountComponentAtNode(container);
      },
    };
  },
};
